module.exports = __webpack_public_path__ + "static/media/clipjoint.ed4afc7a.png";